import DataSerie from './DataSerie'

/**
 * HPLC parser
 */
export function HPLCSummaryDataParser(data) {
  const xValues = []
  if (data.I0) {
    for (let i = 0; i < data.I0.length; i++) {
      xValues[i] = i
    }
  }

  const dataSerie1 = new DataSerie('I0', xValues, data.I0, '#0066CC', 'I0', false)
  const dataSerie2 = new DataSerie('sum_I', xValues, data.sum_I, '#00FF00', 'sum_I', false)
  const dataSerie3 = new DataSerie('Rg', xValues, data.Rg, '#21610B', 'Rg', false)
  const dataSerie4 = new DataSerie('Mass', xValues, data.mass, '#FF9900', 'Mass', false)
  const dataSerie5 = {}

  const dataSerieError1 = new DataSerie('I0StdDev', [], [], '', '', true)
  const dataSerieError3 = new DataSerie('RgStdDev', [], [], '', '', true)
  const dataSerieError4 = new DataSerie('MassStdDev', [], [], '', '', true)

  let dataSerieError1Index = 0
  let dataSerieError3Index = 0
  let dataSerieError4Index = 0

  if (data.I0) {
    for (let j1 = 0; j1 < data.I0.length; j1++) {
      if (dataSerieError1Index === 0) {
        dataSerieError1.pushPoint(Number(j1), Number(data.I0[0]) + Number(data.I0_Stdev[0]))
        dataSerieError1.pushPoint(Number(j1), Number(data.I0[0]) - Number(data.I0_Stdev[0]))
      } else {
        dataSerieError1.addPointByIndex(
          Number(j1),
          Number(data.I0[j1]) + Number(data.I0_Stdev[j1]),
          dataSerieError1Index
        )
        dataSerieError1.addPointByIndex(
          Number(j1),
          Number(data.I0[j1]) - Number(data.I0_Stdev[j1]),
          dataSerieError1.values.x.length - dataSerieError1Index
        )
      }
      dataSerieError1Index++
    }
  }

  if (data.Rg) {
    for (let j2 = 0; j2 < data.Rg.length; j2++) {
      if (dataSerieError3Index === 0) {
        dataSerieError3.pushPoint(Number(j2), Number(data.Rg[0]) + Number(data.Rg_Stdev[0]))
        dataSerieError3.pushPoint(Number(j2), Number(data.Rg[0]) - Number(data.Rg_Stdev[0]))
      } else {
        dataSerieError3.addPointByIndex(
          Number(j2),
          Number(data.Rg[j2]) + Number(data.Rg_Stdev[j2]),
          dataSerieError3Index
        )
        dataSerieError3.addPointByIndex(
          Number(j2),
          Number(data.Rg[j2]) - Number(data.Rg_Stdev[j2]),
          dataSerieError3.values.x.length - dataSerieError3Index
        )
      }
      dataSerieError3Index++
    }
  }

  if (data.mass) {
    for (let j3 = 0; j3 < data.mass.length; j3++) {
      if (dataSerieError4Index === 0) {
        dataSerieError4.pushPoint(Number(j3), Number(data.mass[0]) + Number(data.mass_Stdev[0]))
        dataSerieError4.pushPoint(Number(j3), Number(data.mass[0]) - Number(data.mass_Stdev[0]))
      } else {
        dataSerieError4.addPointByIndex(
          Number(j3),
          Number(data.mass[j3]) + Number(data.mass_Stdev[j3]),
          dataSerieError4Index
        )
        dataSerieError4.addPointByIndex(
          Number(j3),
          Number(data.mass[j3]) - Number(data.mass_Stdev[j3]),
          dataSerieError4.values.x.length - dataSerieError4Index
        )
      }
      dataSerieError4Index++
    }
  }

  if (data.profiles && data.wavelengths) {
    const result = {}

    let j = 0
    for (let i = 0; i < data.profiles.length; i++) {
      // FIXME bmo20210210
      // eslint-disable-next-line no-prototype-builtins
      if (!result.hasOwnProperty(j)) {
        result[j] = []
      }
      result[j].push(data.profiles[i])
      j++

      if (j === data.wavelengths.length) {
        j = 0
      }
    }

    for (let i = 0; i < data.wavelengths.length; i++) {
      if (data.wavelengths[i] !== 0) {
        const myxValues = []
        for (let k = 0; k < result[i].length; k++) {
          myxValues[k] = k
        }

        dataSerie5[i] = new DataSerie('UvAbsorption', myxValues, result[i], 'purple', data.wavelengths[i], false)
      }
    }
  }

  return {
    commonSeries: {
      I0: dataSerie1,
      sum_I: dataSerie2,
      Rg: dataSerie3,
      Mass: dataSerie4,
      I0StdDev: dataSerieError1,
      RgStdDev: dataSerieError3,
      MassStdDev: dataSerieError4,
    },
    UvAbsorption: data.profiles && data.wavelengths && dataSerie5,
    FirstFrameTime: data.FirstFrameTime ? data.FirstFrameTime[0] : null,
    FrameTimePeriod: data.FrameTimePeriod ? data.FrameTimePeriod[0] : null,
    UVtoSAXSoffset: data.UVtoSAXSoffset ? data.UVtoSAXSoffset[0] : null,
    // 'FirstFrameTime':  390,
    // 'FrameTimePeriod': 1,
    // 'UVtoSAXSoffset': -2,
    elutionFlux: data.elutionFlux ? data.elutionFlux[0] : null,
  }
}
